import type {DiffEntry} from '../../../conversation-types'
import {StaticUnifiedDiffPreview} from '../StaticUnifiedDiffPreview'
import {SuggestionFileDisclosure, type SuggestionFileDisclosureLayoutProps} from './SuggestionFileDisclosure'
import styles from './AutomatedReviewDiffEntry.module.css'
import {clsx} from 'clsx'

export function AutomatedReviewDiffEntry({
  diffEntry,
  ...layoutProps
}: {
  diffEntry: DiffEntry
} & SuggestionFileDisclosureLayoutProps) {
  return (
    <SuggestionFileDisclosure path={diffEntry.path} {...layoutProps}>
      <StaticUnifiedDiffPreview
        // TODO(@aliceclv): pass tabSize dynamically
        tabSize={4}
        className={clsx('m-0 border-bottom borderColor-default overflow-hidden', styles.automatedReviewDiff)}
        diffTableClassName="borderColor-default"
        diffLines={diffEntry.diffLines}
      />
    </SuggestionFileDisclosure>
  )
}
